/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/resources/ts/jquery.psfGuidedSearch.ts");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/resources/ts/jquery.psfGuidedSearch.ts":
/*!****************************************************!*\
  !*** ./src/resources/ts/jquery.psfGuidedSearch.ts ***!
  \****************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

///<reference types="jquery"/>
(function ($, window, document) {
    /**
     * A sample jQuery plugin written in Typescript.
     */
    var Plugin = /** @class */ (function () {
        /**
         * Initializes a new instance of the plugin.
         *
         * @param element   The DOM element.
         * @param options   Plugin options.
         */
        function Plugin(element, options) {
            this.defaults = {};
            this.i18n = window['global'].configuration.data.psf.i18n.guidedSearch;
            this.COMPONENT_DEFAULT_STATE = {
                currentStep: 1,
                currentPath: undefined,
                steps: [{
                        stepNumber: 1,
                        stepName: window['global'].configuration.data.psf.psfGuidedSearch.entry.name,
                        stepText: undefined,
                        stepFacet: undefined,
                        active: true,
                        selectedValues: []
                    }]
            };
            this.selectionMapping = {};
            this.allSelectedOptions = {};
            this.element = element;
            this.$element = $(element);
            // extend default options
            this.options = $.extend({}, this.defaults, options);
            this.configData = window['global'].configuration.data.psf.psfGuidedSearch;
            this.componentState = $.extend(true, {}, this.COMPONENT_DEFAULT_STATE);
            // init plugin
            this.init();
        }
        /**
         * Initialization.
         */
        Plugin.prototype.init = function () {
            var _a;
            var data = this.configData;
            this.$showLinkParentContainer = $('.' + this.options.showLinkParent);
            this.$stepWrapper = this.$element.find('.psfGuidedSearch__stepWrapper');
            this.$dropDownWrapper = this.$element.find('.psfGuidedSearch__dropdownWrapper');
            this.$continueButton = this.$element.find('.psfGuidedSearch__continueButton');
            this.$resultsLink = this.$element.find('.psfGuidedSearch__numberOfResultsLink');
            this.searchUrl = this.$element.data('search-url');
            this.resultsUrl = this.$element.data('results-url');
            this.dropdownUrl = this.$element.data('guided-url');
            // fill selectionMapping object with configured data
            for (var _i = 0, _b = this.configData.entry.dropDowns[0].steps; _i < _b.length; _i++) {
                var option = _b[_i];
                Object.assign(this.selectionMapping, (_a = {}, _a[option.value] = option.type, _a));
            }
            this.changeSubHeadlineTo(data.entry.title);
            this.appendDropDownsToComponent(data.entry);
            this.renderStepsWithListeners();
            this.addEventHandlers();
        };
        Plugin.prototype.addEventHandlers = function () {
            var _this = this;
            this.$element.find('.psfGuidedSearch__close, .psfGuidedSearch__cancelButton').on('click', function () {
                _this.$element.trigger('psfGuidedSearch.close');
            });
            this.$continueButton.on('click', function (event) {
                _this.continueToNextStep();
                //this.updateResultsCount();
            });
            this.$resultsLink.on('click', function (event) {
                event.preventDefault();
                _this.setCurrentStepData();
                _this.finishGuidedSearch();
            });
            this.addEventToSelectBox();
        };
        Plugin.prototype.createFinishButton = function () {
            var _this = this;
            this.$continueButton.text(this.resultsCounter);
            this.$element.on('psfGuidedSearch.updateResultCounter', function () {
                _this.$continueButton.text(_this.resultsCounter + ' ' + _this.i18n.finishButtonText);
            });
        };
        Plugin.prototype.continueToNextStep = function () {
            var currentStep = this.componentState.currentStep;
            var data = this.configData;
            this.setCurrentStepData();
            this.componentState.currentStep++;
            var currentPath = this.componentState.currentPath;
            if (currentStep + 1 <= data[currentPath].length + 1) {
                this.prepareNextStep();
            }
            else {
                this.finishGuidedSearch();
            }
        };
        Plugin.prototype.isValidSelection = function () {
            var isValidSelectionValues = true;
            this.$element.find('.selectbox:not(.selectbox--hidden)').each(function (index, selectbox) {
                if ($(selectbox).val() === '') {
                    isValidSelectionValues = false;
                }
            });
            return isValidSelectionValues;
        };
        Plugin.prototype.setCurrentStepData = function () {
            var _a, _b;
            var currentStep = this.componentState.currentStep;
            var currentStepArrayElement = currentStep - 1;
            this.componentState.steps[currentStepArrayElement].active = false;
            this.componentState.steps[currentStepArrayElement].selectedValues = this.extendSelectedValuesBySelect();
            if (currentStep === 1) {
                this.componentState.currentPath = this.getCurrentPathFromSelect();
                this.componentState.steps[currentStepArrayElement].stepText = this.getCurrentTitleForPath();
                Object.assign(this.allSelectedOptions, (_a = {}, _a[currentStep] = [this.selectedOption], _a));
            }
            else {
                this.componentState.steps[currentStepArrayElement].stepText = this.getCurrentTitleFromSelect();
                Object.assign(this.allSelectedOptions, (_b = {}, _b[currentStep] = this.componentState.steps[currentStepArrayElement].selectedValues, _b));
            }
        };
        Plugin.prototype.prepareNextStep = function () {
            var currentStep = this.componentState.currentStep;
            var currentPath = this.componentState.currentPath;
            var data = this.configData;
            this.pushNewStepObject();
            this.changeSubHeadlineTo(data[currentPath][currentStep - 2].title);
            this.requestAndProcessFacetsFromApi(data[currentPath][currentStep - 2].facet);
            this.renderStepsWithListeners();
        };
        Plugin.prototype.pushNewStepObject = function () {
            var currentStep = this.componentState.currentStep;
            var currentPath = this.componentState.currentPath;
            var data = this.configData;
            var stepData = {
                stepNumber: currentStep,
                stepName: data[currentPath][currentStep - 2].name,
                stepFacet: data[currentPath][currentStep - 2].facet,
                stepText: undefined,
                active: true,
                selectedValues: []
            };
            this.componentState.steps.push(stepData);
        };
        Plugin.prototype.renderStepsWithListeners = function () {
            var _this = this;
            var $stepsTpl = this.createStepsMarkup(this.componentState);
            $stepsTpl.find('.psfGuidedSearch__stepLink').on('click', function (event) {
                event.preventDefault();
                _this.goBackToStep($(event.currentTarget).data('step'));
            });
            this.$stepWrapper.empty().append($stepsTpl);
        };
        Plugin.prototype.addEventToSelectBox = function () {
            var _this = this;
            this.$element.find('select').on('change', function (event) {
                for (var key in _this.selectionMapping) {
                    if (key === $(event.target).val()) {
                        _this.selectionMapping[key].log;
                        _this.selectedOption = _this.selectionMapping[key];
                    }
                }
                _this.updateResultsCount();
            });
        };
        Plugin.prototype.goBackToStep = function (stepNumber) {
            this.componentState.currentStep = stepNumber;
            var currentStep = stepNumber;
            var currentPath = this.componentState.currentPath;
            var data = this.configData;
            // remove selected option(s) of current step and above from allSelectedOptions object
            var getSteps = Object.keys(this.allSelectedOptions).map(function (n) { return parseInt(n, 10); });
            for (var i = currentStep; i <= Math.max.apply(Math, getSteps); i++) {
                delete this.allSelectedOptions[i];
            }
            if (stepNumber === 1) {
                this.componentState = $.extend(true, {}, this.COMPONENT_DEFAULT_STATE);
                this.$continueButton.addClass('is-disabled');
                this.changeSubHeadlineTo(data.entry.title);
                this.appendDropDownsToComponent(data.entry);
                this.addEventToSelectBox();
            }
            else {
                this.componentState.steps = this.componentState.steps.slice(0, stepNumber - 1);
                this.pushNewStepObject();
                this.changeSubHeadlineTo(data[currentPath][currentStep - 2].title);
                this.requestAndProcessFacetsFromApi(data[currentPath][currentStep - 2].facet);
            }
            this.renderStepsWithListeners();
        };
        Plugin.prototype.getCurrentTitleForPath = function () {
            var currentPath = this.componentState.currentPath;
            var pathTitle = '';
            this.configData.entry.dropDowns[0].steps.forEach(function (element) {
                if (element.value === currentPath) {
                    pathTitle = element.name;
                }
            });
            return pathTitle;
        };
        Plugin.prototype.getCurrentTitleFromSelect = function () {
            var stepText = '';
            this.$element.find('.selectbox:not(.selectbox--hidden)').each(function (index, selectbox) {
                if (stepText.length === 0) {
                    stepText += $(selectbox).children('option').filter(':selected').text();
                }
                else {
                    stepText += ' / ' + $(selectbox).children('option').filter(':selected').text();
                }
            });
            return stepText;
        };
        Plugin.prototype.changeSubHeadlineTo = function (headline) {
            this.$element.find('.psfGuidedSearch__subHeadline').text(headline);
        };
        Plugin.prototype.createStepsMarkup = function (stepsData) {
            var tplSteps = window['global'].configuration.data.tpl.psfGuidedSearchSteps(stepsData);
            return $(tplSteps);
        };
        Plugin.prototype.createDropdownsMarkup = function (dropDownData, filterData) {
            var tplData = '';
            if (this.componentState.currentStep === 1) {
                tplData = window['global'].configuration.data.tpl.psfGuidedSearchDropdowns(dropDownData);
            }
            else {
                // get i18n data for dropdowns
                var i18n = { all: window['global'].configuration.get('psf.i18n').guidedSearch.all, subCategories: window['global'].configuration.get('psf.i18n').guidedSearch.subCategories };
                // get only data that matches the actual facet
                var activeFilterData = dropDownData.results[0].filter.find(function (dropDownData) { return dropDownData.name === filterData; });
                if (typeof activeFilterData === 'undefined') {
                    activeFilterData = dropDownData.results[0].filter.find(function (dropDownData) { return dropDownData.name === filterData.split(':')[0]; });
                }
                // add i18n properties {
                activeFilterData.i18n = activeFilterData.i18n || {};
                Object.assign(activeFilterData.i18n, i18n);
                // create dropdown template
                tplData = window['global'].configuration.data.tpl.psfGuidedSearchFacetDropdowns(activeFilterData);
            }
            return $(tplData);
        };
        Plugin.prototype.extendSelectedValuesBySelect = function () {
            var currentSelectedValues = [];
            this.$element.find('.selectbox').each(function (index, selectbox) {
                currentSelectedValues.push($(selectbox).val());
            });
            return currentSelectedValues;
        };
        Plugin.prototype.getCurrentPathFromSelect = function () {
            if (this.$element.find('.selectbox').val() !== '') {
                return this.$element.find('.selectbox').val();
            }
        };
        Plugin.prototype.getFilterLanguageParameter = function () {
            return '&lang=' + window['global'].configuration.get('currentLanguageId').toLowerCase();
        };
        Plugin.prototype.requestAndProcessFacetsFromApi = function (facetsName) {
            var _this = this;
            // get previous selected facets
            var previousSelectedFacets = 'filter=';
            if (Object.getOwnPropertyNames(this.allSelectedOptions).length !== 0) {
                for (var _i = 0, _a = Object.keys(this.allSelectedOptions); _i < _a.length; _i++) {
                    var key = _a[_i];
                    var facets = this.allSelectedOptions[key].map(function (facet) { return encodeURIComponent(facet); }).join('&filter=');
                    previousSelectedFacets += facets + "&filter=";
                }
            }
            // request new facets for dropdown and results
            $.ajax({
                url: this.dropdownUrl + '?' + previousSelectedFacets + encodeURIComponent(facetsName) + '&q=*&actualQ=*' + this.getFilterLanguageParameter(),
                crossDomain: true
            }).done(function (ajaxData) {
                facetsName = facetsName.replace(':all', '');
                _this.facetName = facetsName;
                _this.processFacetsData(ajaxData);
            });
        };
        Plugin.prototype.processFacetsData = function (facetData) {
            this.appendDropDownsToComponent(facetData);
        };
        Plugin.prototype.setDropdownAccess = function ($selectbox, enable) {
            if ($selectbox.val() === $selectbox.find('option').first().val() && enable === false) {
                $selectbox.next().addClass('selectbox--hidden').attr('disabled', 'disabled');
            }
            else {
                $selectbox.next().removeClass('selectbox--hidden').removeAttr('disabled');
            }
        };
        Plugin.prototype.appendDropDownsToComponent = function (dropDownData) {
            var _this = this;
            var filterValue;
            if (this.facetName) {
                filterValue = this.facetName;
            }
            var dropDowns = this.createDropdownsMarkup(dropDownData, filterValue);
            dropDowns.closest('select').each(function (index, elem) {
                if ($(elem).next('select').length !== 0) {
                    _this.setDropdownAccess($(elem), false);
                }
                else {
                    _this.setDropdownAccess($(elem), true);
                }
            });
            dropDowns.closest('select').on('change', function (event) {
                if ($(event.target).hasClass('selectbox--valued')) {
                    //if not a sub-selectbox changes remove selected options for sub selectbox
                    if (!$(event.target).hasClass('selectbox__sub')) {
                        $(event.target).next('select').children('option:selected').prop("selected", false);
                        _this.requestAndProcessFacetsFromApi($(event.target).val());
                    }
                    _this.prepareSearchUrl();
                    _this.updateResultsCount();
                }
                else {
                    _this.facetData = $(event.target).val();
                    if (_this.isValidSelection() === false) {
                        _this.$continueButton.addClass('is-disabled');
                    }
                    else {
                        _this.$continueButton.removeClass('is-disabled');
                    }
                    _this.prepareSearchUrl();
                }
            });
            this.$dropDownWrapper.empty().append(dropDowns);
        };
        Plugin.prototype.updateResultsCount = function () {
            var _this = this;
            var ajaxUrl = this.resultsUrl + this.prepareResultCounterParam();
            // call api
            $.ajax({
                url: ajaxUrl
            }).done(function (data) {
                _this.$resultsLink.text(data.results[0].availableDocumentCount + ' ' + _this.i18n.results);
                _this.resultsCounter = data.results[0].availableDocumentCount;
                _this.$element.trigger('psfGuidedSearch.updateResultCounter');
            });
        };
        Plugin.prototype.finishGuidedSearch = function () {
            var searchUrlWithParams = this.prepareSearchUrl(true);
            window.location.href = searchUrlWithParams;
        };
        Plugin.prototype.prepareSearchUrl = function (exit) {
            var _this = this;
            if (exit === void 0) { exit = false; }
            var searchUrlWithParams = this.searchUrl + '?';
            if (Object.getOwnPropertyNames(this.allSelectedOptions).length !== 0) {
                for (var _i = 0, _a = Object.keys(this.allSelectedOptions); _i < _a.length; _i++) {
                    var key = _a[_i];
                    if (parseInt(key) > 1) {
                        searchUrlWithParams += '&';
                    }
                    var facets = this.allSelectedOptions[key].map(function (facet) { return encodeURIComponent(facet); }).join('&filter=');
                    searchUrlWithParams += "filter=" + facets;
                }
            }
            if (!exit) {
                this.$element.find('.selectbox:not(.selectbox--hidden)').each(function (index, selectbox) {
                    var selectedValue = $(selectbox).children('option').filter(':selected').val();
                    if (_this.selectionMapping.hasOwnProperty(selectedValue)) {
                        selectedValue = _this.selectionMapping[selectedValue];
                    }
                    if (searchUrlWithParams.slice(-1) === '?') {
                        searchUrlWithParams = searchUrlWithParams + 'filter=' + encodeURIComponent(selectedValue) + '&';
                    }
                    else {
                        searchUrlWithParams = searchUrlWithParams + '&filter=' + encodeURIComponent(selectedValue) + '&';
                    }
                });
            }
            return searchUrlWithParams;
        };
        Plugin.prototype.prepareResultCounterParam = function () {
            var _this = this;
            var params = '&';
            this.$element.find('.selectbox:not(.selectbox--hidden)').each(function (index, selectbox) {
                var selectedValue = $(selectbox).children('option').filter(':selected').val();
                if (!$(selectbox).hasClass('selectbox_sub') && $(selectbox).val() === $(event.target).children('option:first').val()) {
                    selectedValue = '';
                }
                if (selectedValue.length !== 0) {
                    if (_this.selectionMapping.hasOwnProperty(selectedValue)) {
                        selectedValue = _this.selectionMapping[selectedValue];
                    }
                    params = params + 'filter=' + encodeURIComponent(selectedValue) + '&';
                }
            });
            if (typeof this.selectedOption !== 'undefined' && params.indexOf(encodeURIComponent(this.selectedOption)) === -1) {
                params = params + 'filter=' + this.selectedOption + '&';
            }
            this.componentState.steps.forEach(function (step) {
                if (typeof step.stepFacet !== 'undefined') {
                    step.selectedValues.forEach(function (value) {
                        params = params + 'filter=' + encodeURIComponent(value) + '&';
                    });
                }
            });
            return params;
        };
        Plugin.NAME = 'psfGuidedSearch';
        return Plugin;
    }());
    $.fn[Plugin.NAME] = function (options) {
        return this.each(function () {
            var $this = $(this);
            if (!$this.data(Plugin.NAME)) {
                $this.data(Plugin.NAME, new Plugin(this, options));
            }
        });
    };
})(jQuery, window, document);
//# sourceURL=jquery.psfGuidedSearch.ts


/***/ })

/******/ });
//# sourceMappingURL=jquery.psfGuidedSearch.js.map